import { useState } from "react";
import { ExportAccountDataModal } from "./ExportAccountDataModal";
import { IconButton } from "../IconButton";
import { ExportDataIcon } from "../../images";
import { EllipsisTooltip } from "../CustomTooltip";

export const ExportAccountDataBtn = ({
  account_id,
  campaign_id,
  is_analyzed,
  total_members_with_playbook,
}: {
  account_id: string;
  campaign_id: string;
  is_analyzed: boolean;
  total_members_with_playbook: number;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  return (
    <>
      <EllipsisTooltip
        tooltip={
          !is_analyzed && total_members_with_playbook === 0
            ? "You haven’t analysed company yet"
            : "Export"
        }
      >
        <IconButton
          icon={<ExportDataIcon />}
          onClick={() => setIsOpen(true)}
          disabled={!is_analyzed && total_members_with_playbook === 0}
        />
      </EllipsisTooltip>

      {isOpen && (
        <ExportAccountDataModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          account_id={account_id}
          campaign_id={campaign_id}
          total_members_with_playbook={total_members_with_playbook}
          isOnlyPlaybook={!is_analyzed && total_members_with_playbook > 0}
        />
      )}
    </>
  );
};
